import { put, takeLatest, call, select } from 'redux-saga/effects';
import CHATBOT_SETTINGS_TYPES from './_actionTypes';
import chatbotSettingsHelper from '../../../utils/API/BackendHelper/admin/chatbotSettings';

function* handleFetchSettings() {
  try {
    const response = yield call([chatbotSettingsHelper, chatbotSettingsHelper.getSettings]);
    const settings = response?.data?.settings ?? response?.data;
    yield put({
      type: CHATBOT_SETTINGS_TYPES.FETCH_SETTINGS_SUCCESS,
      payload: { settings },
    });
  } catch (error) {
    yield put({
      type: CHATBOT_SETTINGS_TYPES.FETCH_SETTINGS_FAILURE,
      payload: { error: error.message },
    });
  }
}

function* handleUpdateSettings(action) {
  try {
    const response = yield call(
      [chatbotSettingsHelper, chatbotSettingsHelper.updateSettings],
      action.payload
    );
    const settings = response?.data?.settings ?? response?.data;
    yield put({
      type: CHATBOT_SETTINGS_TYPES.UPDATE_SETTINGS_SUCCESS,
      payload: { settings },
    });
    // Re-fetch to confirm saved value
    yield put({ type: CHATBOT_SETTINGS_TYPES.FETCH_SETTINGS_REQUEST });
  } catch (error) {
    yield put({
      type: CHATBOT_SETTINGS_TYPES.UPDATE_SETTINGS_FAILURE,
      payload: { error: error.message },
    });
  }
}

function* handleFetchUsageStats(action) {
  try {
    const days = action.payload?.days ?? (yield select((s) => s.adminChatbotSettings.daysFilter));
    const response = yield call(
      [chatbotSettingsHelper, chatbotSettingsHelper.getUsageStats],
      days
    );
    const stats = response?.data?.stats ?? response?.data ?? [];
    yield put({
      type: CHATBOT_SETTINGS_TYPES.FETCH_USAGE_STATS_SUCCESS,
      payload: { stats },
    });
  } catch (error) {
    yield put({
      type: CHATBOT_SETTINGS_TYPES.FETCH_USAGE_STATS_FAILURE,
      payload: { error: error.message },
    });
  }
}

function* chatbotSettingsSaga() {
  yield takeLatest(CHATBOT_SETTINGS_TYPES.FETCH_SETTINGS_REQUEST, handleFetchSettings);
  yield takeLatest(CHATBOT_SETTINGS_TYPES.UPDATE_SETTINGS_REQUEST, handleUpdateSettings);
  yield takeLatest(CHATBOT_SETTINGS_TYPES.FETCH_USAGE_STATS_REQUEST, handleFetchUsageStats);
}

export default chatbotSettingsSaga;
